export default {
    state: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
    mutations: {
        mut_resize: state => {
            const vh = window.innerHeight * 0.01;

            document.documentElement.style.setProperty('--vh', `${vh}px`);

            state.width = window.innerWidth;
            state.height = window.innerHeight;
        },
    },
    actions: {
        resize: ctx => ctx.commit('mut_resize'),
    },
    getters: {
        width: state => state.width,
        height: state => state.height,
        is_collapsed: state => state.width < 800,
    },
};
